import { getErrorMessage } from '@gozoki/api';
import * as Sentry from '@sentry/react';

export const getErrorMessageWithSentry = (error: unknown) => {
    return getErrorMessage(error, (e) => {
        Sentry.captureException(e);
    });
};
